import { render, staticRenderFns } from "./square-fields.vue?vue&type=template&id=10b8790a&scoped=true&"
import script from "./square-fields.vue?vue&type=script&lang=js&"
export * from "./square-fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8790a",
  null
  
)

export default component.exports